<i class="btn-close icon-edponline-Bop-071" (click)="close()"  aria-hidden="true"></i>
<div class="d-flex flex-column justify-content-center align-items-center p-5">
    <div class="container my-4 px-0 px-md-5 text-sm-left text-md-center">
        <div class="row" *ngIf="data.type === modalType.SUCCESS || data.type === modalType.ERROR">
            <div class="col-12">
                <i *ngIf="data.type === modalType.SUCCESS" class="icon-edponline-Bop-072 success icon-size m-3" aria-hidden="true"></i>
                <i *ngIf="data.type === modalType.ERROR" class="icon-edponline-Bop-071 error icon-size  m-3" aria-hidden="true"></i>
            </div>
        </div>
        <h3 *ngIf="data.title" class="mt-5 mt-md-2" [ngClass]="{'success': data.type === modalType.SUCCESS, 'error': data.type === modalType.ERROR }">{{data?.title}}</h3>
        <p *ngIf="data.message" class="message p-0 m-0" [innerHTML]="data.message"></p>
        <p *ngIf="data.messageHTML" class="message" [innerHTML]="data.messageHTML"></p>
        <a *ngIf="data.link && !isApp"
            href="{{ data.link }}"
            [appOperationHistory]="'SHOWCASE_MORE_INFO'"
            class="d-inline-block pack-link"
            target="_system">
            <span class="font-mulish font-weight-medium font-type">{{ "pt.edp.edponline.pack.more.info" | translate }}</span>
        </a>

        <a *ngIf="data.link && !!isApp"
            [edpExternalLink]="data.link"
            [appOperationHistory]="'SHOWCASE_MORE_INFO'"
            class="d-inline-block pack-link"
        >
            <span class="font-mulish font-weight-medium font-type">{{ "pt.edp.edponline.pack.more.info" | translate }}</span>
        </a>
    </div>
</div>